import {
  CLOSE_SEARCH_BUYER_PANEL_SUCCESS,
  OPEN_SEARCH_BUYER_PANEL_SUCCESS,
  GET_ENTITY_BUYER_PANEL_OPTIONS,
  GET_ENTITY_BUYER_PANEL_OPTIONS_ERROR,
  GET_ENTITY_BUYER_PANEL_OPTIONS_SUCCESS
} from './SearchBuyerPanel.actions'

const searchBuyerPanelState = {
  open: false,
  error: null,
  loading: false,
  options: []
}

/**
 * The search buyer panel's reducer.
 */
const searchBuyerPanelReducer = (state = searchBuyerPanelState, { payload, type }) => {
  switch (type) {
    case CLOSE_SEARCH_BUYER_PANEL_SUCCESS: {
      return { ...state, open: false }
    }
    case OPEN_SEARCH_BUYER_PANEL_SUCCESS: {
      return { ...state, open: true }
    }
    case GET_ENTITY_BUYER_PANEL_OPTIONS: {
      return { ...state, open: true, loading: true }
    }
    case GET_ENTITY_BUYER_PANEL_OPTIONS_ERROR: {
      return { ...state, open: true, error: payload.error, loading: false }
    }
    case GET_ENTITY_BUYER_PANEL_OPTIONS_SUCCESS: {
      return {
        ...state,
        open: true,
        loading: false,
        options: payload.options
      }
    }
    default: {
      return state
    }
  }
}

export default searchBuyerPanelReducer
